class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', (event) => {
      if(event.target.name === 'sort_by'){
        FacetFiltersForm.currentSort=event.target.value;
        document.querySelectorAll('[name=sort_by]').forEach(input=>input.value=event.target.value);
      }
      this.debouncedOnSubmit(event);
    });

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    const canonical = new URLSearchParams(searchParams);
    const sort=canonical.get('sort_by');if(sort)canonical.set('sort_by',sort);
    searchParams=canonical.toString();
    FacetFiltersForm.currentSort=sort || '';
    document.querySelectorAll('[name=sort_by]').forEach(input=>{if(sort)input.value=sort;});
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const updateEvent = FacetFiltersForm.startUpdateEvent(searchParams);
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner',
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event, updateEvent)
        : FacetFiltersForm.renderSectionFromFetch(url, event, updateEvent);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static startUpdateEvent(searchParams) {
    const { SearchUpdateEvent, CollectionUpdateEvent } = window.StandardEvents || {};
    if (!SearchUpdateEvent && !CollectionUpdateEvent) return;

    const facetsForm = document.querySelector('facet-filters-form');
    const facetsContainer = document.querySelector('.facets-container');
    const collectionId = facetsContainer?.dataset.collectionId || null;
    const collectionHandle = facetsContainer?.dataset.collectionHandle || '';
    const currentCount = parseInt(document.getElementById('ProductCount')?.dataset.productCount) || 0;
    const urlSearchParams = new URLSearchParams(searchParams);
    const isSearchPage = facetsContainer?.dataset.template === 'search';
    const isCollectionPage = facetsContainer?.dataset.template === 'collection';
    const dispatchTarget = facetsForm || document;

    let deferred;

    if (isSearchPage) {
      deferred = SearchUpdateEvent.createPromise();
      dispatchTarget.dispatchEvent(
        new SearchUpdateEvent({
          search: {
            query: urlSearchParams.get('q') || '',
            productFilters: SearchUpdateEvent.parseProductFilters(urlSearchParams),
            sortKey: SearchUpdateEvent.getSortKey(urlSearchParams),
          },
          promise: deferred.promise,
        }),
      );
    } else if (isCollectionPage) {
      // collectionId is null for auto-generated collections (/collections/all,
      // /collections/vendors/<x>, etc.) — the SSE schema accepts that.
      deferred = CollectionUpdateEvent.createPromise();
      dispatchTarget.dispatchEvent(
        new CollectionUpdateEvent({
          collection: { id: collectionId, handle: collectionHandle, productsCount: currentCount },
          productFilters: CollectionUpdateEvent.parseProductFilters(urlSearchParams),
          sortKey: CollectionUpdateEvent.getSortKey(urlSearchParams),
          promise: deferred.promise,
        }),
      );
    }

    if (!deferred) return;
    deferred.promise.catch(() => {});

    return {
      resolve: (filteredCount) => {
        deferred.resolve({ [isSearchPage ? 'totalCount' : 'productsCount']: filteredCount });
      },
      reject: deferred.reject,
    };
  }

  static renderSectionFromFetch(url, event, updateEvent) {
    fetch(url)
      .then((response) => {if(!response.ok)throw Error('Filters could not be updated. Please try again.');return response.text();})
      .then((html) => {
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        const requested=new URL(url,location.origin).searchParams;requested.delete('section_id');
        if(requested.toString() !== FacetFiltersForm.searchParamsPrev){updateEvent?.resolve(0);return;}
        FacetFiltersForm.renderSection(html, event, updateEvent);
      })
      .catch((error) => {
        const container=document.getElementById('ProductGridContainer');
        let message=document.getElementById('yd-filter-error');
        if(!message){message=document.createElement('p');message.id='yd-filter-error';message.className='yd-filter-error';message.setAttribute('role','status');container.prepend(message);}
        message.textContent='Filters could not be updated. The previous results are still displayed. Choose a filter again to retry.';
        document.querySelectorAll('.loading').forEach(el=>el.classList.remove('loading'));
        document.querySelectorAll('.facets-container .loading__spinner').forEach(el=>el.classList.add('hidden'));
        updateEvent?.reject(error);
      });
  }

  static renderSectionFromCache(filterDataUrl, event, updateEvent) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderSection(html, event, updateEvent);
  }

  static renderSection(html, event, updateEvent) {
    document.getElementById('yd-filter-error')?.remove();
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html, updateEvent);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html, updateEvent) {
    const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
    const sourceCount = parsedHtml.getElementById('ProductCount');
    const count = sourceCount.innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.dataset.productCount = sourceCount.dataset.productCount || '';
    container.dataset.totalCount = sourceCount.dataset.totalCount || '';
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner',
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));

    updateEvent?.resolve(parseInt(sourceCount.dataset.productCount) || 0);
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter',
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter',
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (!isTextInput) {
          // Try to return focus to the same checkbox the user just toggled,
          // re-selecting it from the freshly rendered HTML by its id.
          const originatingInputId = event.target.id;
          const matchingInput = originatingInputId
            ? newFacetDetailsElement.querySelector(`#${CSS.escape(originatingInputId)}`)
            : null;

          if (matchingInput) {
            matchingInput.focus();
          } else {
            // Fallback to summary/close button if the checkbox can't be found
            const fallbackSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
              ? `.mobile-facets__close-button`
              : `.facets__summary`;
            const fallbackElement = newFacetDetailsElement.querySelector(fallbackSelector);
            if (fallbackElement) fallbackElement.focus();
          }
        }
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    const incoming=new URLSearchParams(searchParams), out=new URLSearchParams();
    for(const [key,value] of incoming){
      if(key==='sort_by')continue;
      if(key.startsWith('filter.') && !key.startsWith('filter.v.price')){if(!out.getAll(key).includes(value))out.append(key,value);}
      else out.set(key,value);
    }
    const sort=FacetFiltersForm.currentSort || new URLSearchParams(location.search).get('sort_by') || incoming.get('sort_by');
    if(sort)out.set('sort_by',sort);
    const current=new URLSearchParams(location.search);
    for(const [key,value] of current)if(['q','type','options[prefix]'].includes(key)&&!out.has(key))out.set(key,value);
    FacetFiltersForm.renderPage(out.toString(), event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    const params=new URLSearchParams(url), current=new URLSearchParams(location.search);
    for(const key of ['sort_by','q','type','options[prefix]'])if(current.has(key))params.set(key,current.get(key));
    FacetFiltersForm.renderPage(params.toString());
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  static averages = new Map();

  constructor() {
    super();
    this.controls = this.querySelector('.yd-price-controls');
    this.simple = this.controls.classList.contains('yd-price-controls--simple');
    this.minInput = this.querySelector('[data-yd-price-number="min"]');
    this.maxInput = this.querySelector('[data-yd-price-number="max"]');
    this.minSlider = this.querySelector('[data-price-slider="min"]');
    this.maxSlider = this.querySelector('[data-price-slider="max"]');
    this.limit = Number(this.controls.dataset.rangeMax);
    this.currency = this.controls.dataset.currency;
    this.money = new Intl.NumberFormat('en-GB', { style: 'currency', currency: this.currency });
    this.status = this.querySelector('[data-price-status]');
    this.averageButton = this.querySelector('[data-price-average]');
    this.addEventListener('input', (event) => {
      if (event.target === this || event.ydPriceCommit) return;
      event.stopPropagation();
      const role = event.target.dataset.priceSlider;
      if (role) {
        const value = Number(event.target.value);
        if (this.simple) {
          // A legacy minimum remains in its chip until the shopper changes this ceiling.
          this.minInput.value = '';
          this.maxInput.value = (Math.max(0, Math.min(this.limit, value)) / 100).toFixed(2);
          this.sync();
          return;
        }
        const other = role === 'min' ? Number(this.maxSlider.value) : Number(this.minSlider.value);
        const bounded = role === 'min' ? Math.min(value, other) : Math.max(value, other);
        (role === 'min' ? this.minInput : this.maxInput).value = (bounded / 100).toFixed(2);
        event.target.value = bounded;
        this.sync();
      }
    });
    this.addEventListener('change', (event) => {
      if (event.target.matches('input')) this.commit(event.target.dataset.priceSlider || event.target.dataset.ydPriceNumber);
    });
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' && event.target.dataset.ydPriceNumber) {
        event.preventDefault();
        this.commit(event.target.dataset.ydPriceNumber);
      }
    });
    this.averageButton?.addEventListener('click', (event) => {
      event.stopImmediatePropagation();
      this.applyAverage();
    }, { capture: true });
    this.sync();
    this.lastCommitted = this.signature();
    this.showAverage();
  }

  parse(input, fallback) {
    const raw = input.value.trim();
    if (!raw) return fallback;
    let value = raw.replace(/[\s']/g, '');
    if (value.includes(',')) {
      if (value.includes('.')) value = value.replace(/,/g, '');
      else value = /,\d{1,2}$/.test(value) ? value.replace(',', '.') : value.replace(/,/g, '');
    }
    if (!/^-?\d+(?:\.\d+)?$/.test(value)) return NaN;
    return Math.round(Number(value) * 100);
  }

  sync() {
    const low = this.parse(this.minInput, 0), high = this.parse(this.maxInput, this.limit);
    if (this.simple) {
      this.maxSlider.value = Math.max(0, Math.min(this.limit, Number.isFinite(high) ? high : this.limit));
      const text = this.money.format(Number(this.maxSlider.value) / 100);
      this.maxSlider.setAttribute('aria-valuetext', text);
      this.querySelector('[data-price-max-output]').textContent = text;
      return;
    }
    this.minSlider.value = Math.max(0, Math.min(this.limit, Number.isFinite(low) ? low : 0));
    this.maxSlider.value = Math.max(Number(this.minSlider.value), Math.min(this.limit, Number.isFinite(high) ? high : this.limit));
    for (const [role, slider] of [['min', this.minSlider], ['max', this.maxSlider]]) {
      const text = this.money.format(Number(slider.value) / 100);
      slider.setAttribute('aria-valuetext', text);
      this.querySelector(`[data-price-${role}-output]`).textContent = text;
    }
  }

  signature() {
    return [this.minInput.value === '' ? '' : this.parse(this.minInput, 0), this.maxInput.value === '' ? '' : this.parse(this.maxInput, this.limit)].join('|');
  }

  commit(changed) {
    let low = this.parse(this.minInput, 0), high = this.parse(this.maxInput, this.limit);
    if (!Number.isFinite(low) || !Number.isFinite(high)) {
      this.status.textContent = 'Enter a valid price, such as 59.95.';
      const invalid = !Number.isFinite(low) ? this.minInput : this.maxInput;
      invalid.setAttribute('aria-invalid', 'true');
      invalid.focus();
      return;
    }
    low = Math.max(0, Math.min(this.limit, low));
    high = Math.max(0, Math.min(this.limit, high));
    if (low > high) {
      if (changed === 'min') low = high;
      else high = low;
    }
    for (const input of [this.minInput, this.maxInput]) input.removeAttribute('aria-invalid');
    if (this.minInput.value !== '') this.minInput.value = (low / 100).toFixed(2);
    if (this.maxInput.value !== '') this.maxInput.value = (high / 100).toFixed(2);
    this.status.textContent = '';
    this.sync();
    const signature = this.signature();
    if (signature === this.lastCommitted) return;
    this.lastCommitted = signature;
    const event = new Event('input', { bubbles: true });
    if (this.simple) {
      // Keep the native debounce and use the range's ID for focus restoration after AJAX.
      event.ydPriceCommit = true;
      this.maxSlider.dispatchEvent(event);
    } else {
      this.dispatchEvent(event);
    }
  }

  averageContext() {
    const { collectionId, collectionHandle, collectionUrl, country } = this.controls.dataset;
    const url = new URL(collectionUrl, location.origin);
    const route = `${window.Shopify.routes.root.replace(/\/$/, '')}/collections/${collectionHandle}`;
    const currentPath = location.pathname.replace(/\/$/, '');
    if (!/^[a-z0-9][a-z0-9-]*$/.test(collectionHandle || '') || url.origin !== location.origin || url.pathname !== route || url.search || url.hash || currentPath !== route || country !== window.Shopify.country || this.currency !== window.Shopify.currency.active) throw new Error('Collection price context changed.');
    const automaticAll = collectionId === '' && collectionHandle === 'all';
    if (!automaticAll && !/^[1-9]\d*$/.test(collectionId || '')) throw new Error('Collection identity is missing.');
    return { id: automaticAll ? null : collectionId, handle: collectionHandle, route, country, currency: this.currency };
  }

  averageKey(context = this.averageContext()) {
    return JSON.stringify([context.id, context.handle, context.route, context.currency, context.country]);
  }

  matchesAverageContext(data, context) {
    const sameId = context.id === null
      ? data?.collectionId === null && context.handle === 'all'
      : Number.isSafeInteger(data?.collectionId) && data.collectionId > 0 && String(data.collectionId) === context.id;
    return sameId && data.collectionHandle === context.handle && data.collectionUrl === context.route && data.requestPath === context.route && data.currency === context.currency && data.country === context.country;
  }

  showAverage() {
    if (!this.averageButton) return;
    let key;
    try { key = this.averageKey(); } catch { return; }
    const value = PriceRange.averages.get(key);
    if (!value || Date.now() - value.at > 300000) return;
    this.averageButton.textContent = `Up to average price · ${this.money.format(value.cents / 100)}`;
    this.querySelector('[data-price-average-help]').textContent = `Mean starting price of ${value.count} available products across this collection. Calculated ${new Date(value.at).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}.`;
  }

  async calculateAverage() {
    const context = this.averageContext();
    const key = this.averageKey(context);
    const cached = PriceRange.averages.get(key);
    if (cached && Date.now() - cached.at < 300000) return cached;
    const products = new Map();
    let expected, pages = 1;
    for (let page = 1; page <= pages; page++) {
      const url = new URL(context.route, location.origin);
      url.searchParams.set('section_id', 'yd-collection-prices');
      url.searchParams.set('page', String(page));
      url.searchParams.set('_price_read', String(Date.now()));
      const response = await fetch(url, { cache: 'no-store', headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error('Collection prices could not be read.');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const data = JSON.parse(html.querySelector('#yd-collection-price-data')?.textContent || 'null');
      if (!data || !this.matchesAverageContext(data, context) || this.averageKey() !== key || data.page !== page || !Array.isArray(data.products)) throw new Error('Collection price context changed.');
      if (page === 1) {
        expected = data.total;
        pages = data.pages;
        if (!Number.isInteger(expected) || expected < 1 || expected > 25000 || !Number.isInteger(pages) || pages < 1 || pages > 100) throw new Error('Collection prices are incomplete.');
      }
      if (data.total !== expected || data.pages !== pages) throw new Error('Collection changed while reading prices.');
      for (const product of data.products) {
        if (!Number.isSafeInteger(product.id) || !Number.isSafeInteger(product.price) || typeof product.available !== 'boolean' || products.has(product.id)) throw new Error('Collection prices are incomplete.');
        products.set(product.id, product);
      }
    }
    if (products.size !== expected) throw new Error('Collection prices are incomplete.');
    const eligible = [...products.values()].filter(product => product.available && product.price > 0);
    if (!eligible.length) throw new Error('No eligible collection prices.');
    const cents = Math.round(eligible.reduce((sum, product) => sum + product.price, 0) / eligible.length);
    const result = { cents, count: eligible.length, at: Date.now() };
    PriceRange.averages.set(key, result);
    return result;
  }

  async applyAverage() {
    if (this.averageButton.disabled) return;
    this.averageButton.disabled = true;
    this.status.textContent = 'Reading collection prices…';
    try {
      const average = await this.calculateAverage();
      if (!this.isConnected) return;
      if (average.cents > this.limit) throw new Error('Average exceeds this filter range.');
      this.minInput.value = '';
      this.maxInput.value = (average.cents / 100).toFixed(2);
      this.showAverage();
      this.commit('max');
    } catch (error) {
      if (this.isConnected) this.status.textContent = 'The collection average could not be calculated. You can still choose a price range.';
    } finally {
      if (this.isConnected) this.averageButton.disabled = false;
    }
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
